export default __webpack_public_path__ + "static/media/A4PosterRight2.5ffaad01.png";